import { z } from "zod";
import { extendZodWithOpenApi } from "zod-openapi";
import { BlockConfigErrorSchema } from "./errors";
import { ActionIdPlaceholder, BlockIdPlaceholder } from "utils/regex";
import { FilterOperatorSchema } from "server/schemas/table-records";

extendZodWithOpenApi(z);

export const ActionIdPlaceholderSchema = z.string().regex(ActionIdPlaceholder);

export const BlockBaseSchema = z
  .object({
    errors: z.array(BlockConfigErrorSchema).optional(),
  })
  .openapi({ ref: "InterfaceBlockBase" });

export const BlockIdSchema = z
  .string()
  .cuid()
  .or(z.string().regex(BlockIdPlaceholder));

export const ComponentBlockStyleSchema = z.object({
  width: z
    .union([
      z.literal("full"),
      z.literal("wide"),
      z.literal("medium"),
      z.literal("narrow"),
    ])
    .optional(),
  alignment: z
    .union([z.literal("left"), z.literal("center"), z.literal("right")])
    .optional(),
});

export type ComponentBlockStyle = z.infer<typeof ComponentBlockStyleSchema>;

export const FilterConditionSchema = z.object({
  fieldId: z.number(),
  operator: FilterOperatorSchema.or(z.literal("currentUser")),
  value: z.union([
    z.string().min(1),
    z.number(),
    z.boolean(),
    z.array(z.string().min(1)),
  ]),
});

export type FilterCondition = z.infer<typeof FilterConditionSchema>;

export const FilterSchema = z.object({
  conditions: z.array(FilterConditionSchema),
});

export type FieldFilter = z.infer<typeof FilterSchema>;
